import { cn } from "@/lib/utils";

export default function WidgetGrid({
  children,
  className,
  ...rest
}: React.ComponentProps<"div">) {
  return (
    <div
      {...rest}
      className={cn("grid grid-cols-12 gap-2 @container/grid", className)}
    >
      {children}
    </div>
  );
}
